import * as React from 'react';
import Actions from './Actions';

const Ar = () => {
    return(
        <Actions/>
    );
};
export default Ar;